<template>
  <div class="dashboard container">

      <FileManager v-if="client" :client="client" :folder="folder" :file="file"></FileManager>
      <!-- <v-btn class="logout-btn" @click="logout">Log out</v-btn> -->
      <!-- $route.params.id -->
  </div>
</template>

<script>
  import firebase from 'firebase';
  import FileManager from './admin/FileManager.vue';
  import db from '../main.js';
  import store from '../store/store.js';

  export default {
    name: 'dashboard',
    components: {
      FileManager
    },
    store: store,
    computed: {
      isMobile: function() {
        console.log(screen.width);
        if (screen.width <= 768) {
          return true;
        }
        return false;
      }
    },
    data: function() {
      return {
        company: null,
        client: null,
        folder: null,
        file: null,
        clients: []
      }
    },
    computed: {
      user() {
        return this.$store.getters.getUser;
      },
      isAdmin() {
        return this.$store.getters.getAdmin;
      }
    },
    mounted() {
      var self=this;
      db.collection('users').where('id', '==', firebase.auth().currentUser.uid).get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          console.log(doc.id, ' => ', doc.data())
          if (!self.$route.params.client) {
            self.company = doc.data().company
          } else if (self.isAdmin && self.$route.params.client) {
            self.company = self.$route.params.client
          }
        })
      })
      db.collection('companies').get().then((querySnapshot) => {
        this.loading = false
        querySnapshot.forEach((doc) => {
          let data = {
            'uid': doc.id,
            'name': doc.data().name
          }
          self.clients.push(data)
        })
      })
      setTimeout(function () {
        self.client = self.clients.find(client => client.name === self.company);
      }, 1000);

    },
    created() {
      console.log(this.$route);
      this.company = this.$route.params.client;
      this.folder = this.$route.params.folder;
      this.file = this.$route.params.file;
    },
    updated() {
      console.log(this.$route);
      this.company = this.$route.params.client;
      this.folder = this.$route.params.folder;
      this.file = this.$route.params.file;
    },
    methods: {
      logout: function() {
        firebase.auth().signOut().then(() => {
          this.$router.replace('login')
        })
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .dashboard {
    margin-top: 40px;
    position: relative;
  }

</style>
